import {
  enableAutoTrack,
  isPurposeAllowed,
  mixpanel,
  normalizeTelemetryConsent,
  sentry,
} from '@affine/track';
import { appSettingAtom } from '@toeverything/infra';
import { useAtomValue } from 'jotai/react';
import { useEffect } from 'react';

import {
  installDiagnosticTelemetryListeners,
  installProductAnalyticsListeners,
} from '../../bootstrap/telemetry';

let diagnosticsListenersInstalled = false;
let analyticsListenersInstalled = false;

export function Telemetry() {
  const settings = useAtomValue(appSettingAtom);

  useEffect(() => {
    const consent = normalizeTelemetryConsent(settings);
    const analyticsAllowed = isPurposeAllowed(consent, 'productAnalytics');
    const diagnosticsAllowed = isPurposeAllowed(consent, 'crashDiagnostics');

    void mixpanel.configure(analyticsAllowed);
    if (diagnosticsAllowed) {
      sentry.init(true);
      sentry.enable();
      if (!diagnosticsListenersInstalled) {
        installDiagnosticTelemetryListeners();
        diagnosticsListenersInstalled = true;
      }
    } else {
      sentry.close();
    }
    if (analyticsAllowed && !analyticsListenersInstalled) {
      installProductAnalyticsListeners();
      analyticsListenersInstalled = true;
    }
    return analyticsAllowed
      ? enableAutoTrack(document.body, mixpanel.track)
      : undefined;
  }, [settings]);

  return null;
}
